/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import clsx from 'clsx';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  MenuItem,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import CustomDropdown from '../../../../components/CustomDropdown';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import useDashboard from '../../../../hooks/useDashboard';
import useForms from '../../../../hooks/useForms';
import usePractice from '../../../../hooks/usePractice';
import HistoricPerformanceRevenue from '.././HistoricPerformanceRevenue';
import HistoricPerformanceGross from '.././HistoricPerformanceGross';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import BarChartIcon from '@material-ui/icons/BarChart';
/* Modal */
import useMediaQuery from '@material-ui/core/useMediaQuery';
import InfoIcon from '@material-ui/icons/Info';
import { useTheme } from '@material-ui/core/styles';
import useStyles from '../../Main.style';
import { ReactComponent as LineAxisIcon } from '../../../../assets/images/LineAxisFilled.svg';

//const MyPerformanceSalesUser = () => {
const MyPerformanceSalesUser = React.memo(function MyPerformanceSalesUser({
  cellListFromMyCellTab,
  averageGrossFromMyCell,
}) {
  /* Modal */
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [dropdownValue, setDropdownValue] = useState('');
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [cellHistoricTableData, setCellHistoricTableData] = useState([]);

  const [chartTypeCountry, setCountryChartType] = useState('column');
  const [yearlyGrossData, setYearlyGrossData] = useState([]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    getUserHistoricRevenue,
    getUserHistoricGross,
    getAverageGrossProfitPerFileWithDate,
    getAverageGrossProfitPerFileForUser,
  } = useDashboard();
  const { getPrTargets } = useForms();
  const [startYearHistoric, setStartYearHistoric] = useState('');
  const [selectedCellValue, setSelectedCellValue] = useState(loggedInUserData?.cell?.cellValue);
  const [selectedCountryValue, setSelectedCountryValue] = useState(
    loggedInUserData?.country?.countryValue,
  );
  const countryMonthNames = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };
  const [averageGross, setAverageGross] = useState([]);
  const [userSelectionChart2, setUserSelectionChart2] = useState('');
  const [monthlyGrossData, setMonthlyGrossData] = useState([]);
  const [endYearChart2, setEndYearChart2] = useState(new Date().getFullYear().toString());
  const [rollingData, setRollingData] = useState([]);
  const [monthlyRevenueData, setMonthlyRevenueData] = useState([]);
  const [yearlyRevenueData, setYearlyRevenueData] = useState([]);
  const [userSelectionRevenue1, setUserSelectionRevenue1] = useState('');
  const [currentYearDataRevenue, setCurrentYearDataRevenue] = useState([]);
  const [countryAverageGrossYearly, setCountryAverageGrossYearly] = useState([]);
  const [endYearOptionsChart2, setEndYearOptionsChart2] = useState([]);
  const [countryAverageGrossMonthly, setCountryAverageGrossMonthly] = useState([]);
  const [endYearOptionsHistoricRevenue, setEndYearOptionsHistoricRevenue] = useState([]);
  const [endYearHistoric, setEndYearHistoric] = useState(new Date().getFullYear().toString());
  const [yearlyRevenueTarget, setYearlyRevenueTarget] = useState([]);
  const [currentYearDataGross, setCurrentYearDataGross] = useState([]);
  const [averageGrossMonthly, setAverageGrossMonthly] = useState([]);
  const [startYearChart1, setStartYearChart1] = useState(null);
  const [startYearChart2, setStartYearChart2] = useState(null);
  const [averageGrossYearly, setAverageGrossYearly] = useState([]);
  const [yearlyRevenueGross, setYearlyRevenueGross] = useState([]);
  const [rollingDataGross, setRollingDataGross] = useState([]);
  const [userSelectionChart1, setUserSelectionChart1] = useState('');
  const { fetchAllCellList } = usePractice();
  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
    setSelectedCellValue(event.target.value);
  };
  let months;

  if (Object.keys(averageGrossMonthly).length > 0) {
    const countryData = Object.values(averageGrossMonthly);
    months = Object.keys(countryData[0]);
  } else {
    const countryData = Object.values(averageGross);
    months = Array.from(new Set(countryData.flatMap((country) => Object.keys(country))));
  }

  const getColor = (country) => {
    switch (country) {
      case 'UNITED STATES':
        return '#f15b40';
      case 'MEXICO':
        return '#6eaaa0';
      case 'CHILE':
        return '#0f6e8c';

      default:
        return undefined;
    }
  };

  let series = [];
  const startYear = startYearChart2;
  const endYear = endYearChart2;

  if (userSelectionChart2 === 'yearly') {
    if (startYear && endYear) {
      Object.keys(averageGrossYearly).forEach((year) => {
        const yearData = averageGrossYearly[year];
        yearData.forEach((countryData) => {
          const countryName = countryData?.employee;
          const averageProfitPerFile = countryData?.averageProfitPerFile;

          let countrySeries = series.find((seriesItem) => seriesItem.name === countryName);
          if (!countrySeries) {
            countrySeries = {
              name: countryName == loggedInUserData?.userName ? 'My Performance' : 'Top Performer',
              data: [],
              color: countryName == loggedInUserData?.userName ? '#003c6f' : '#1e611d',
            };
            series.push(countrySeries);
          }

          countrySeries.data.push(averageProfitPerFile);
        });
      });
    }
  } else if (userSelectionChart2 === 'monthly') {
    if (Object.keys(averageGrossMonthly).length > 0) {
      const countryNames = Object.keys(averageGrossMonthly);
      series = countryNames.map((employee) => ({
        name: employee == loggedInUserData?.userName ? 'My Performance' : 'Top Performer',
        data: months.map(
          (month) => averageGrossMonthly[employee][month]?.averageProfitPerFile || 0,
        ),
        color: (() => {
          employee == loggedInUserData?.userName ? '#003c6f' : '#1e611d';
        })(),
      }));
    } else {
      series = [];
    }
  } else {
    const countryNames = Object.keys(averageGross);
    series = countryNames.map((employee) => ({
      name: employee == loggedInUserData?.userName ? 'My Performance' : 'Top Performer',
      data: months.map((month) => averageGross[employee][month]?.averageProfitPerFile || 0),
      color: (() => {
        employee == loggedInUserData?.userName ? '#003c6f' : '#1e611d';
      })(),
    }));
  }

  let xAxisCategories = [];

  if (userSelectionChart2 === 'yearly') {
    if (Object.keys(averageGrossYearly).length > 0) {
      xAxisCategories = Object.keys(averageGrossYearly);
    } else {
      xAxisCategories = months.map((month) => countryMonthNames[month]);
    }
  } else if (userSelectionChart2 === 'monthly') {
    if (Object.keys(averageGrossMonthly).length > 0) {
      xAxisCategories = months.map((month) => countryMonthNames[month]);
    } else {
      xAxisCategories = months.map((month) => countryMonthNames[month]);
    }
  } else {
    xAxisCategories = months.map((month) => countryMonthNames[month]);
  }
  let countryMonths;

  let countrySeries = [];

  if (Object.keys(countryAverageGrossMonthly).length > 0) {
    const countryData = Object.values(countryAverageGrossMonthly);
    countryMonths = Object.keys(countryData[0]);
  } else {
    const countryData = Object.values(averageGross);
    countryMonths = Array.from(new Set(countryData.flatMap((country) => Object.keys(country))));
  }

  let countryXAxisCategories;

  if (userSelectionChart1 === 'yearly') {
    countryXAxisCategories = Object.keys(countryAverageGrossYearly);
  } else if (userSelectionChart1 === 'monthly') {
    countryXAxisCategories = countryMonths.map((month) => countryMonthNames[month]);
  } else {
    countryXAxisCategories = countryMonths.map((month) => countryMonthNames[month]);
  }
  if (userSelectionChart1 === 'yearly') {
    if (Object.keys(countryAverageGrossYearly).length > 0) {
      Object.keys(countryAverageGrossYearly).forEach((year) => {
        const yearData = countryAverageGrossYearly[year];
        yearData.forEach((countryData) => {
          const countryName = countryData?.employee;
          const averageProfitPerFile = countryData?.averageProfitPerFile;

          let countrySeriesItem = countrySeries.find(
            (seriesItem) => seriesItem.name === countryName,
          );
          if (!countrySeriesItem) {
            countrySeriesItem = {
              name: countryName == loggedInUserData?.userName ? 'My Performance' : 'Top Performer',
              data: [],
              color: countryName == loggedInUserData?.userName ? '#003c6f' : '#1e611d',
            };
            countrySeries.push(countrySeriesItem);
          }

          countrySeriesItem.data.push(averageProfitPerFile);
        });
      });
    } else {
      countrySeries = [];
    }
  } else if (userSelectionChart1 === 'monthly') {
    if (Object.keys(countryAverageGrossMonthly).length > 0) {
      const countryNames = Object.keys(countryAverageGrossMonthly);
      //const countryNames = ["My Perofrmance","Top Performer"];
      countrySeries = countryNames.map((employee) => ({
        name: employee == loggedInUserData?.userName ? 'My Performance' : 'Top Performer',
        data: countryMonths.map(
          (month) => countryAverageGrossMonthly[employee][month]?.averageProfitPerFile || 0,
        ),
        color: (() => {
          employee == loggedInUserData?.userName ? '#003c6f' : '#1e611d';
        })(),
      }));
    } else {
      series = [];
    }
  } else {
    const countryNames = Object.keys(averageGross);
    countrySeries = countryNames.map((employee) => ({
      name: employee == loggedInUserData?.userName ? 'My Performance' : 'Top Performer',
      data: countryMonths.map((month) => averageGross[employee][month]?.averageProfitPerFile || 0),
      color: (() => {
        employee == loggedInUserData?.userName ? '#003c6f' : '#1e611d';
      })(),
    }));
  }
  const handleCountryChartTypeChange = (event, newChartType) => {
    if (newChartType !== null) {
      setCountryChartType(newChartType);
    }
  };

  // const fetchAverageGrossProfit = async () => {
  //   const response = await getAverageGrossProfitPerFileWithDate(); // Assuming your API endpoint is at '/api/getOptimalInvoiceDelta'
  //   //setAverageGross(response?.countryData);
  // };

  const fetchAverageGrossProfitUser = async () => {
    const response = averageGrossFromMyCell; // Assuming your API endpoint is at '/api/getOptimalInvoiceDelta'
    setAverageGross(response?.countryData);
  };
  const loadAllCells = async () => {
    const allCellList = cellListFromMyCellTab?.filter(
      (cell) => cell?.countryId === loggedInUserData?.countryId,
    );
    setDropdownOptions(allCellList?.myCountryCells);
  };

  const handleEndYearHistoric = (value) => {
    setEndYearHistoric(value);
    setStartYearChart1(value);
  };

  const handleApplyHistoric = async () => {
    setStartYearHistoric(startYearHistoric ? startYearHistoric : endYearHistoric);
    const response = await getUserHistoricRevenue({
      startYear: startYearHistoric === null ? endYearHistoric : startYearHistoric,
      endYear: endYearHistoric,
      userName: loggedInUserData?.userName,
    });

    const responseGross = await getUserHistoricGross({
      startYear: startYearHistoric === null ? endYearHistoric : startYearHistoric,
      endYear: endYearHistoric,
      userName: loggedInUserData?.userName,
    });

    const responseData2 = await getAverageGrossProfitPerFileWithDate({
      startYear: startYearHistoric === null ? endYearHistoric : startYearHistoric,
      endYear: endYearHistoric,
      userName: loggedInUserData?.userName,
    });

    const responseData = await getAverageGrossProfitPerFileForUser({
      startYear: startYearHistoric === null ? endYearHistoric : startYearHistoric,
      endYear: endYearHistoric,
      userName: loggedInUserData?.userName,
    });

    if (responseData?.countryData) {
      setAverageGrossMonthly(responseData?.countryData);
      setUserSelectionChart2('monthly');
    } else if (responseData?.totalAverageProfitPerCountryPerYear) {
      setAverageGrossYearly(responseData?.totalAverageProfitPerCountryPerYear);
      setUserSelectionChart2('yearly');
    } else {
      setUserSelectionChart2('none');
    }

    if (responseData?.countryData) {
      setCountryAverageGrossMonthly(responseData?.countryData);
      setUserSelectionChart1('monthly');
    } else if (responseData?.totalAverageProfitPerCountryPerYear) {
      setCountryAverageGrossYearly(responseData?.totalAverageProfitPerCountryPerYear);
      setUserSelectionChart1('yearly');
    } else {
      setCountryAverageGrossYearly({});
      setUserSelectionChart1('none');
    }

    if (responseGross?.monthlyHistoricGross) {
      setMonthlyGrossData(responseGross?.monthlyHistoricGross);
      setUserSelectionRevenue1('monthly');
    } else if (responseGross?.yearToDateGross) {
      setCurrentYearDataGross(responseGross?.yearToDateGross);
      setUserSelectionRevenue1('currentYear');
    } else if (responseGross?.yearlyHistoricGross) {
      setYearlyGrossData(responseGross?.yearlyHistoricGross);
      setUserSelectionRevenue1('yearly');
    } else {
      setUserSelectionChart1('none');
    }

    if (response?.monthlyHistoricRevenue) {
      setMonthlyRevenueData(response?.monthlyHistoricRevenue);
      setUserSelectionRevenue1('monthly');
    } else if (response?.yearToDateRevenue) {
      setCurrentYearDataRevenue(response?.yearToDateRevenue);
      setUserSelectionRevenue1('currentYear');
    } else if (response?.yearlyHistoricRevenue) {
      setYearlyRevenueData(response?.yearlyHistoricRevenue);
      setUserSelectionRevenue1('yearly');
    } else {
      setUserSelectionChart1('none');
    }
  };

  const averageCountryGrossProfit = {
    chart: {
      type: chartTypeCountry,
    },
    title: {
      text: ' ',
    },
    xAxis: {
      categories: countryXAxisCategories,
      title: {
        text: '',
      },
    },
    yAxis: {
      title: {
        text: 'Profit (USD)',
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    series: countrySeries,
  };
  const generateEndYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear();
    const possibleEndYears = [];
    for (let year = startYear; year <= currentYear; year++) {
      possibleEndYears.push(year);
    }
    return possibleEndYears;
  };

  const handleStartYearHistoric = (value) => {
    setStartYearHistoric(value);
    setStartYearChart2(value);
    const possibleEndYears = generateEndYearOptions(value);
    setEndYearOptionsHistoricRevenue(possibleEndYears);
  };

  useEffect(() => {
    loadAllCells();
    //fetchAverageGrossProfit();
    fetchAverageGrossProfitUser();
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setEndYearOptionsHistoricRevenue([...generateEndYearOptions(currentYear)]);
  }, []);

  useEffect(() => {
    if (startYearChart2 !== null) {
      const possibleEndYears = Array.from(
        { length: new Date().getFullYear().toString() - startYearChart2 + 1 },
        (_, index) => startYearChart2 + index,
      );
      setEndYearOptionsChart2(possibleEndYears);
      if (!possibleEndYears.includes(parseInt(endYearChart2))) {
        setEndYearChart2(possibleEndYears[0]);
      }
    } else {
      setEndYearChart2(new Date().getFullYear().toString());
      setEndYearOptionsChart2([new Date().getFullYear().toString()]);
    }
  }, [startYearChart2, endYearChart2]);

  useEffect(() => {
    const fetchHistoricRollingData = async () => {
      try {
        const response = await getUserHistoricRevenue({ userName: loggedInUserData?.userName });
        const responseGross = await getUserHistoricGross({
          userName: loggedInUserData?.userName,
        });
        const revenueTarget = await getPrTargets({
          userId: loggedInUserData?.id,
        });

        setRollingData(response?.twelveMonthlyHistoricRevenue);
        setRollingDataGross(responseGross?.twelveMonthlyHistoricGross);
        setYearlyRevenueTarget(revenueTarget?.usersResult);
        setYearlyRevenueGross(revenueTarget?.usersResult);
      } catch (error) {
        console.error('Error fetching historic rolling data:', error);
      }
    };

    fetchHistoricRollingData();
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between" alignItems="flex-end">
                {/* <Typography variant="h5">Historic Performance</Typography> */}
                <Box className={classes.CompanyOperationalPerformanceFilter}>
                  <Box>
                    <Select
                      value={startYearHistoric}
                      onChange={(e) => handleStartYearHistoric(e.target.value)}
                    >
                      <MenuItem value={null}>--</MenuItem>
                      {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - (4 - i)).map(
                        (year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ),
                      )}
                    </Select>
                  </Box>
                  <Box mx={1}>
                    <Typography variant="body1">to</Typography>
                  </Box>
                  <Box>
                    <Select
                      value={endYearHistoric}
                      onChange={(e) => handleEndYearHistoric(e.target.value)}
                    >
                      {endYearOptionsHistoricRevenue.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <Box ml={2}>
                    <Button variant="outlined" color="primary" onClick={handleApplyHistoric}>
                      Apply
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={classes.innercontentWhite}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h5" noWrap>
                    REVENUE (USD)
                  </Typography>
                  <InfoIcon aria-haspopup="true" className={classes.InfoIconStyle} />
                </Box>
                <Box mt={1}>
                  <HistoricPerformanceRevenue
                    userSelectionRevenue1={userSelectionRevenue1}
                    yearlyRevenueData={yearlyRevenueData}
                    monthlyRevenueData={monthlyRevenueData}
                    rollingData={rollingData}
                    currentYearDataRevenue={currentYearDataRevenue}
                    yearlyRevenueTarget={yearlyRevenueTarget}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={classes.innercontentWhite}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h5" noWrap>
                    GROSS PROFIT (USD)
                  </Typography>
                  <InfoIcon aria-haspopup="true" className={classes.InfoIconStyle} />
                </Box>
                <Box mt={1}>
                  <HistoricPerformanceGross
                    userSelectionRevenue1={userSelectionRevenue1}
                    yearlyGrossData={yearlyGrossData}
                    monthlyGrossData={monthlyGrossData}
                    rollingDataGross={rollingDataGross}
                    currentYearDataGross={currentYearDataGross}
                    yearlyRevenueGross={yearlyRevenueGross}
                  />
                  {/* Other chart component */}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                className={classes.innercontentWhite}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={{ height: '100%' }}
              >
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <Box mr={1}>
                      <Typography variant="h5">Average Gross Profit per File</Typography>
                    </Box>
                    <Box display="flex">
                      <InfoIcon />
                    </Box>
                  </Box>
                  <Box className={classes.GraphToggle}>
                    <ToggleButtonGroup
                      value={chartTypeCountry}
                      exclusive
                      onChange={handleCountryChartTypeChange}
                      aria-label="chart-type"
                    >
                      <ToggleButton value="column" aria-label="Bar">
                        <BarChartIcon />
                      </ToggleButton>
                      <ToggleButton value="line" aria-label="Line">
                        <LineAxisIcon />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Box mt={1} width="100%">
                    <HighchartsReact highcharts={Highcharts} options={averageCountryGrossProfit} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});

export default MyPerformanceSalesUser;
